var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66466 15.2872C5.66466 15.0896 5.73745 14.892 5.89345 14.736C6.19505 14.4344 6.69425 14.4344 6.99585 14.736L12.7575 20.4976L18.5191 14.736C18.8207 14.4344 19.3199 14.4344 19.6215 14.736C19.9231 15.0376 19.9231 15.5368 19.6215 15.8384L13.3087 22.1512C13.0071 22.4528 12.5079 22.4528 12.2063 22.1512L5.89345 15.8384C5.73745 15.6824 5.66466 15.4848 5.66466 15.2872Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9791 21.4233L11.9791 3.92014C11.9791 3.49374 12.3327 3.14014 12.7591 3.14014C13.1855 3.14014 13.5391 3.49374 13.5391 3.92014L13.5391 21.4233C13.5391 21.8497 13.1855 22.2033 12.7591 22.2033C12.3327 22.2033 11.9791 21.8497 11.9791 21.4233Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.6de2d26b17265e9e97126741343a7a2d.svg";
export { ForwardRef as ReactComponent };